<template>
    <div>
        <v-select
            v-model="value.code"
            :options="optionlist"
            :reduce="(item) => item.code"
            :placeholder="placeholder"
            label="name"
            @input="changeOption"
        >
            <div slot="no-options">沒有資料可供選擇 !</div>
        </v-select>
    </div>
</template>

<script>

export default {
    name: "ReportSettingCoverageSelect",
    props: {
        value: { 
            type: Object, 
            required: true, 
            default: () => {}
        },
        isdetail: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {};
    },
    computed: {
        optionlist() {
            return JSON.parse(this.isdetail ? localStorage.specialConditionList : localStorage.coverageOptionList)
        },
        placeholder() {
            if (this.value.code) {
                let codename = this.optionlist.filter(x => x.code === this.value.code)[0].code_name;
                return this.value.code+' '+codename
            } else {
                return "請選擇或輸入"
            }
        }
    },
    methods: {
        changeOption(val) {
            if (val) {
                this.value.codename = this.optionlist.filter(x => x.code === val)[0].code_name;
            }
        }
    },
    watch: {},
    mounted() {},
};
</script>
